import { useContext, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import FeatureGate from '../../components/FeatureGate'
import { FEATURE_KEYS } from '../../features/featureRegistry'
import roleContext from '../../context/roleContext'
import { useAuth } from '../../modules/auth'
import { RoleContextValue } from '../../types/OtherTypes'
import Applications from './Applications'
import EarnedLeaveEncashment from './EarnedLeaveEncashment'
import LeaveAccount from './LeaveAccount'
import { getLeaveBalances, getPieChartData } from './LeaveFunctions'
import MyLeave from './MyLeave'
import CompOffApproval from './CompOffApproval'
import { useLocation } from 'react-router-dom'


const Leave = () => {
  const { currentUser } = useAuth()
  const location = useLocation()


  let roleState: RoleContextValue = useContext(roleContext)

  // const roleName = roleState.roleName?.toLowerCase()
  const normalizedRoleName = roleState.roleName ?.trim() .toUpperCase() .replace(/_/g, ' ')

  // Check if user is System Admin (admin@ctrine.com or admin@ctrine.in) or has Super Admin role
  const isSystemAdmin = currentUser?.email?.toLowerCase() === 'admin@ctrine.com' ||
    currentUser?.email?.toLowerCase() === 'admin@ctrine.in'

  const isSuperAdmin = normalizedRoleName === 'SUPER ADMIN' || normalizedRoleName === 'SUPERADMIN'
  const isAdmin = normalizedRoleName === 'ADMIN'
  const isRmOrHr = currentUser?.isRmOrHr || false
  const canApprove = currentUser?.isRmOrHr || isSuperAdmin || isSystemAdmin || isAdmin

  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })

  const [balance, setBalance] = useState([])
  const [, setPieChartDate] = useState({})

  // const [activeTab, setActiveTab] = useState(
  //   // Persist selected tab across navigation; default to My Leave unless super admin prefers leaveaccount
  //   () => sessionStorage.getItem('leaveActiveTab') || (roleState.features.includes('super admin') ? 'leaveaccount' : 'myLeave')
  // )
  
  const [activeTab, setActiveTab] = useState(() => {
  const savedTab = sessionStorage.getItem('leaveActiveTab')
    if (savedTab) {
      return savedTab
    }
    return isSuperAdmin ? 'applications' : 'myLeave'
  })
  
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('tab') === 'comp-off') {
      setActiveTab('compoffapproval')
    }
    if (params.get('tab') === 'applications') { 
      setActiveTab('applications') 
    }
  }, [location])


  const handleTabChange = (tab) => {
    setActiveTab(tab)
    sessionStorage.setItem('leaveActiveTab', tab)
  }
  useEffect(() => {
    let mounted = true
    if (mounted) {
      getLeaveBalances(currentUser, setBalance, setAPIStatus)
      // getPieChartData(currentUser, setPieChartDate, setAPIStatus)
    }
    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Row>
        {/* <Col md={4}>
          <div className='card h-80 '>
            <div className='card-header' style={{minHeight: '3rem'}}>
              <div className='card-title'>
                {Number(piechartData?.consumeTotalLeave) === 0
                  ? 'Total Availed '
                  : `Total Availed(${piechartData.consumeTotalLeave})`}
              </div>
            </div>

            <div className='align-items-center mt-2'>
              {Number(piechartData.consumeTotalLeave) === 0 ? (
                <>
                  <div className='ms-2 mt-2 mb-2 me-2'>
                    <div className='fw-bold text-gray-600 text-center  mb-2'>No Data Available</div>
                    <div className='text-center'>
                      <img
                        src='/media/avatars/19-dark.png'
                        alt='noReacordAvailable'
                        style={{width: '110px', height: '85px'}}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <Chart
                  type='donut'
                  width='290'
                  height='290'
                  series={[
                    Number(piechartData.consumeEarnLeave) || 0,
                    Number(piechartData.consumeSickLeave) || 0,
                    Number(piechartData.consumeOptionalLeave) || 0,
                    Number(piechartData.consumeUnpaidLeave) || 0,
                    Number(piechartData.consumedWorkFromHome) || 0,
                  ]}
                  options={{
                    labels: [`Earned Leave`, `Short Leave`, `Optional Leave`, `Unpaid Leave`, `WFH`],
                    colors: ['#128BFF', '#FCBA18', '#d633ff', '#FF0000', '#9FA6B2'],
                    noData: {text: 'empty data'},
                    stroke: {
                      width: 0.5,
                    },
                    legend: {
                      show: true,
                      fontSize: '12px',
                      horizontalAlign: 'center',
                      position: 'right',
                      fontFamily: 'Arial, sans-serif',
                      markers: {
                        width: 6,
                        height: 6,
                      },
                      labels: {
                        colors: 'primary',
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },
                    plotOptions: {
                      pie: {
                        donut: {
                          size: '70%',
                        },
                      },
                    },
                    responsive: [
                      {
                        breakpoint: 1000,
                        options: {
                          plotOptions: {
                            pie: {
                              horizontal: false,
                              dataLabels: {
                                offset: -5,
                              },
                            },
                          },
                          legend: {
                            show: true,
                            position: 'bottom',
                          },
                          chart: {
                            position: 'left',
                          },
                        },
                      },
                    ],
                  }}
                />
              )}
            </div>
          </div>
        </Col> */}
        {!isSuperAdmin && (
          <Col md={12}>
            <div className='card mb-5 mb-xl-10 h-70' id='kt_profile_details_view'>
              <div className='card-header' style={{ minHeight: '3rem' }}>
                <div className='card-title'>Leave Balance</div>
                <div className='card-toolbar'>
                  <button
                    className='btn btn-sm btn-light-primary'
                    onClick={() => {
                      setAPIStatus((prev: any) => ({ ...prev, loading: true }))
                      getLeaveBalances(currentUser, setBalance, setAPIStatus)
                    }}
                    disabled={APIStatus.loading}
                  >
                    {APIStatus.loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Refreshing...
                      </>
                    ) : (
                      <>
                        <i className="ki-duotone ki-arrows-circle fs-2">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        Refresh Balances
                      </>
                    )}
                  </button>
                </div>
              </div>
              <div className='card-body align-items-center '>
                {APIStatus.loading ? (
                  <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '200px' }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading balances...</span>
                    </div>
                    <span className="ms-3">Calculating dynamic leave balances...</span>
                  </div>
                ) : APIStatus.error ? (
                  <div className='alert alert-danger d-flex align-items-center' role="alert">
                    <i className="ki-duotone ki-cross-circle fs-2x text-danger me-4">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <div>
                      <h4 className="alert-heading">Error Loading Leave Balances</h4>
                      <p className="mb-0">{APIStatus.error}</p>
                      <hr />
                      <p className="mb-0">
                        Please check your leave policies and employment type configuration.
                        <br />
                        <small className="text-muted">
                          If the issue persists, contact your HR administrator.
                        </small>
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className='row'>
                    {balance?.length > 0 ? (
                      balance
                        ?.filter((obj: any) => {
                          // Hide Leave without Pay if balance is 0
                          if (obj?.leaveTypeName?.toLowerCase().includes('leave without pay') &&
                            (obj?.balance === '0' || obj?.balance === 0)) {
                            return false;
                          }
                          // Hide Short Leave if utilized is 0 AND balance is 0 (or generally just hide if no activity, but user asked for utilized)
                          // User said: "In local we don't show the Short Leave balance, Once a user submit a request we just show the utilised Short Leave"
                          if (obj?.leaveTypeName?.toLowerCase().includes('short leave')) {
                            // usage is typically in usedLeaves
                            const utilized = Number(obj?.usedLeaves || 0);
                            if (utilized === 0) return false;
                          }
                          return true;
                        })
                        ?.map((obj: {
                          leaveTypeName: string;
                          balance: string;
                          entitledBalance?: number;
                          usedLeaves?: number;
                          policyDetails?: any;
                        }, index, filteredArray) => {
                          const isShortLeave = obj?.leaveTypeName?.toLowerCase().includes('short leave');
                          return (
                            <div
                              key={index}
                              className='col-md-3 text-gray-300'
                              style={{ borderRight: index + 1 === filteredArray?.length ? '' : '1px solid ' }}
                            >
                              <div className='mt-5 text-lg-center'>
                                <div className='fs-3 fw-semibold counted mt-2'>
                                  <span className='text-gray-900'>
                                    {isShortLeave ? (obj?.usedLeaves ?? '0') : (obj?.balance ?? '-')}
                                  </span>
                                </div>
                                <div className='mt-3 text-muted'>
                                  {obj?.leaveTypeName}
                                  {isShortLeave && <span className='fs-9 d-block text-muted'>(Utilized)</span>}
                                </div>
                              </div>
                            </div>
                          )
                        })
                    ) : (
                      <div className='ms-2 mt-2 mb-2 me-2'>
                        <div className='fw-bold text-gray-600 text-center mb-2'>No Leave Policies Found</div>
                        <div className='text-center'>
                          <img
                            src='/media/avatars/19-dark.png'
                            alt='noRecordAvailable'
                            style={{ width: '110px', height: '85px' }}
                          />
                        </div>
                        <div className='text-center mt-3'>
                          <p className='text-muted'>
                            No leave policies are configured for your employment type.
                            <br />
                            Please contact your HR administrator.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>
        )}

        {/* <Col md={2}>
          <div className='card mb-5 mb-xl-10 ' id='kt_profile_details_view'>
            <div className='card-header' style={{minHeight: '3rem'}}>
              <div className='card-title fs-6'>WFH Available</div>
            </div>

            <div className=''>
              <div className=' mt-13 mb-5 text-lg-center'>
                <div className='fs-3 fw-semibold counted  '>{balance?.users?.wfh ?? '-'}</div>
                <div className=' mt-2 text-muted'>Work From Home</div>
                <div className='text-muted'>{`(Monthly)`}</div>
              </div>
            </div>
          </div>
        </Col> */}
      </Row>

      <ul className='nav nav-tabs ms-3 me-3 '>
      {!isSuperAdmin && (
        <li className='nav-item cursor-pointer '>
          <a
            href="#my-leave"
            className={`nav-link ${activeTab === 'myLeave' ? 'active' : ''}`}
            onClick={(e) => { e.preventDefault(); handleTabChange('myLeave'); }}
          >
            My Leave
          </a>
        </li>
        )}
        {canApprove && (
          <li className='nav-item cursor-pointer'>
            <a
              href="#applications"
              className={`nav-link ${activeTab === 'applications' ? 'active' : ''} ${canApprove ? '' : 'disabled text-muted'}`}
              onClick={(e) => { e.preventDefault(); canApprove && handleTabChange('applications'); }}
              title={canApprove ? '' : 'Only RM/HR/Admin can view Applications'}
            >
              Applications
            </a>
          </li>
        )}
        <FeatureGate feature={FEATURE_KEYS.leave_account}>
          <li className='nav-item cursor-pointer'>
            <a
              href="#leave-account"
              className={`nav-link ${activeTab === 'leaveaccount' ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); handleTabChange('leaveaccount'); }}
            >
              Leave Account
            </a>
          </li>
        </FeatureGate>

        {/* <FeatureGate feature={FEATURE_KEYS.comp_off_approval}> */}
        {canApprove && (
        <li className='nav-item cursor-pointer'>
          <a
            href="#comp-off-approval"
            className={`nav-link ${activeTab === 'compoffapproval' ? 'active' : ''} ${canApprove ? '' : 'disabled text-muted'}`}
            onClick={(e) => {
              e.preventDefault()
              if (canApprove) {
                handleTabChange('compoffapproval')
              }
            }}
          >
            Comp-Off Approval
          </a>
        </li>
        )}
        {/* </FeatureGate> */}


        {/* Temporarily hidden as per requirements */}
        {false && (
          <li className='nav-item cursor-pointer'>
            <a
              href="#encashment"
              className={`nav-link ${activeTab === 'encashment' ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); handleTabChange('encashment'); }}
            >
              Earned Leave Encashment
            </a>
          </li>
        )}
      </ul>

      <div className='tab-content p-3'>
        {activeTab === 'myLeave' && (
          <MyLeave
            getLeaveBalances={getLeaveBalances}
            setBalance={setBalance}
            getPieChartData={getPieChartData}
            setPieChartDate={setPieChartDate}
          />
        )}
        {activeTab === 'applications' && (
          <Applications getLeaveBalances={getLeaveBalances} setBalance={setBalance} />
        )}
        {activeTab === 'leaveaccount' && (
          <FeatureGate feature={FEATURE_KEYS.leave_account}>
            <LeaveAccount getLeaveBalances={getLeaveBalances} setBalance={setBalance} />
          </FeatureGate>
        )}
        {activeTab === 'compoffapproval' && <CompOffApproval />}
        {/* Temporarily hidden as per requirements */}
        {false && activeTab === 'encashment' && <EarnedLeaveEncashment />}
      </div>
    </>
  )
}

export default Leave
